import React, { useState, useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  Avatar,
  CircularProgress,
  Button,
  Snackbar,
  Alert,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import EditIcon from "@mui/icons-material/Edit";
import CustomAppBar from "../components/appbar";
import { Buffer } from "buffer";

const REACT_APP_API_USERNAME = process.env.REACT_APP_API_USERNAME;
const REACT_APP_API_PASSWORD = process.env.REACT_APP_API_PASSWORD;
const REACT_APP_EXPRESS_SERVER = process.env.REACT_APP_EXPRESS_SERVER;
const REACT_APP_COMPANY = process.env.REACT_APP_COMPANY;
const REACT_APP_BIDDING_API_DATA_URL =
  process.env.REACT_APP_BIDDING_API_DATA_URL;
const REACT_APP_ACTION_API_DATA_URL = process.env.REACT_APP_ACTION_API_DATA_URL;
const REACT_APP_API_DATA_URL = process.env.REACT_APP_API_DATA_URL;

const UserProfile = () => {
  const [userData, setUserData] = useState({
    vendorNo: "",
    vendorName: "",
    tin: "",
    email: "",
    phoneNo: "",
    currency: "UGX",
    country: "Uganda",
    username: "",
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [validationLoading, setValidationLoading] = useState(false);
  const [contactLoading, setContactLoading] = useState(false);
  const [validationResult, setValidationResult] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editedData, setEditedData] = useState({});
  const [saveLoading, setSaveLoading] = useState(false);
  const [currencies, setCurrencies] = useState([]);
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    const token = Buffer.from(
      `${REACT_APP_API_USERNAME}:${REACT_APP_API_PASSWORD}`,
      "utf8"
    ).toString("base64");

    const fetchOptions = {
      method: "GET",
      headers: {
        Authorization: `Basic ${token}`,
        "Content-Type": "application/json",
      },
    };

    // Fetch currencies
    fetch(
      `${REACT_APP_API_DATA_URL}currencies?${REACT_APP_COMPANY}`,
      fetchOptions
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch currencies: ${response.statusText}`);
        }
        return response.json();
      })
      .then((data) => setCurrencies(data.value))
      .catch((error) => console.error("Error fetching currencies:", error));

    // Fetch countries
    fetch(
      `${REACT_APP_API_DATA_URL}countries?${REACT_APP_COMPANY}`,
      fetchOptions
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch countries: ${response.statusText}`);
        }
        return response.json();
      })
      .then((data) => setCountries(data.value))
      .catch((error) => console.error("Error fetching countries:", error));
  }, []);

  const token = Buffer.from(
    `${REACT_APP_API_USERNAME}:${REACT_APP_API_PASSWORD}`,
    "utf8"
  ).toString("base64");

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const storedEmail = sessionStorage.getItem("email");
        if (!storedEmail) {
          throw new Error("No email found in local storage");
        }

        const response = await fetch(
          `${REACT_APP_EXPRESS_SERVER}/profile/${storedEmail}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch user profile");
        }

        const data = await response.json();
        setUserData(data);
        setEditedData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, []);

  const updateVendorNoOnBackend = async (username, vendorNo) => {
    try {
      const response = await fetch(
        `${REACT_APP_EXPRESS_SERVER}/users/${username}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ vendorNo }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update vendor number on backend");
      }
    } catch (err) {
      console.error("Error updating vendor number:", err);
      throw err;
    }
  };
  const updateVendorDataBackend = async (
    username,
    vendorNo,
    vendorName,
    tin,
    email,
    currency
  ) => {
    try {
      const response = await fetch(
        `${REACT_APP_EXPRESS_SERVER}/users/${username}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            tin: editedData.tin,
            email: editedData.email,
            phoneNo: editedData.phoneNo,
            vendorNo: editedData.vendorNo,
            vendorName: editedData.vendorName,
            currency: editedData.currency,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update vendor Data on backend");
      }
    } catch (err) {
      console.error("Error updating vendor Data:", err);
      throw err;
    }
  };

  const setContacts = async () => {
    setContactLoading(true);
    try {
      const validationResponse = await fetch(
        `${REACT_APP_BIDDING_API_DATA_URL}updateContactOrVendor?${REACT_APP_COMPANY}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${token}`,
          },
          body: JSON.stringify({
            tin: editedData.tin,
            email: editedData.email,
            phoneNo: editedData.phoneNo,
            vendorNo: editedData.vendorNo,
          }),
        }
      );
      // Stting the vendor data as well on the backend

      if (!validationResponse.ok) {
        throw new Error("Validation failed");
      }

      updateVendorDataBackend(
        userData.username,
        editedData.vendorNo,
        userData.vendorName,
        editedData.email,
        editedData.phoneNo,
        editedData.tin,
        editedData.currency
      );

      const result = await validationResponse.json();
      const newVendorNo = result.value;

      if (!newVendorNo) {
        throw new Error("No vendor/ Contanct returned from validation");
      }
      setValidationResult({
        success: true,
        message: `Validation successful! Vendor number: ${newVendorNo}`,
      });
    } catch (err) {
      setValidationResult({
        success: false,
        message: err.message || "Validation failed. Please try again.",
      });
    } finally {
      setContactLoading(false);
    }
  };

  const handleValidate = async () => {
    setValidationLoading(true);
    setValidationResult(null);

    try {
      const validationResponse = await fetch(
        `${REACT_APP_BIDDING_API_DATA_URL}createContactOrVendor?${REACT_APP_COMPANY}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Basic ${token}`,
          },
          body: JSON.stringify({
            name: userData.vendorName,
            tin: userData.tin,
            email: userData.email,
            phoneNo: userData.phoneNo,
            local: true,
            vendorNo: userData.vendorNo || "",
          }),
        }
      );

      if (!validationResponse.ok) {
        throw new Error("Validation failed");
      }

      const result = await validationResponse.json();
      const newVendorNo = result.value;

      if (!newVendorNo) {
        throw new Error("No vendor number returned from validation");
      }

      await updateVendorNoOnBackend(userData.username, newVendorNo);

      const updatedUserData = {
        ...userData,
        vendorNo: newVendorNo,
      };

      setUserData(updatedUserData);
      setEditedData(updatedUserData);
      sessionStorage.setItem("vendorNo", newVendorNo);

      setValidationResult({
        success: true,
        message: `Validation successful! Vendor number: ${newVendorNo}`,
      });
    } catch (err) {
      setValidationResult({
        success: false,
        message: err.message || "Validation failed. Please try again.",
      });
    } finally {
      setValidationLoading(false);
    }
  };

  const handleEdit = () => {
    setIsEditing(true);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setEditedData(userData);
  };

  //   const handleSave = async () => {
  //     setSaveLoading(true);
  //     try {
  //       const response = await fetch(
  //         `${REACT_APP_EXPRESS_SERVER}/users/${userData.username}`,
  //         {
  //           method: "PUT",
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           body: JSON.stringify(editedData),
  //         }
  //       );

  //       if (!response.ok) {
  //         throw new Error("Failed to update profile");
  //       }

  //       const updatedData = await response.json();
  //       setUserData(updatedData);
  //       setIsEditing(false);
  //     } catch (err) {
  //       setError(err.message);
  //     } finally {
  //       setSaveLoading(false);
  //     }
  //   };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCloseSnackbar = () => {
    setValidationResult(null);
  };

  if (loading) {
    return (
      <Box>
        <CustomAppBar active="profile" />
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="60vh"
        >
          <CircularProgress />
        </Box>
      </Box>
    );
  }

  if (error) {
    return (
      <Box>
        <CustomAppBar active="profile" />
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="60vh"
        >
          <Typography color="error">{error}</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box>
      <CustomAppBar active="profile" />
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Box display="flex" flexDirection="column" alignItems="center" mb={4}>
            <Avatar
              sx={{
                width: 100,
                height: 100,
                mb: 2,
                bgcolor: "primary.main",
                fontSize: "2.5rem",
              }}
            >
              {userData.username
                ? userData.username.charAt(0).toUpperCase()
                : "U"}
            </Avatar>
            <Typography variant="h4" component="h1">
              {userData.username || "User Profile"}
            </Typography>

            {!isEditing ? (
              <Button
                startIcon={<EditIcon />}
                onClick={handleEdit}
                sx={{ mt: 2 }}
                variant="outlined"
              >
                Edit Profile
              </Button>
            ) : (
              <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
                <Button
                  startIcon={<SaveIcon />}
                  onClick={setContacts}
                  variant="contained"
                  color="primary"
                  disabled={contactLoading}
                >
                  {saveLoading ? <CircularProgress size={24} /> : "Save"}
                </Button>
                <Button
                  startIcon={<CancelIcon />}
                  onClick={handleCancel}
                  variant="outlined"
                  color="secondary"
                  disabled={saveLoading}
                >
                  Cancel
                </Button>
              </Box>
            )}
          </Box>

          <Box
            display="grid"
            gridTemplateColumns="repeat(auto-fit, minmax(300px, 1fr))"
            gap={3}
          >
            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
                Basic Information
              </Typography>

              {isEditing ? (
                <>
                  <TextField
                    label="Vendor Number"
                    name="vendorNo"
                    value={editedData.vendorNo || ""}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    disabled
                  />
                  <TextField
                    label="Business Name"
                    name="vendorName"
                    value={editedData.vendorName || ""}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    required
                  />
                  <TextField
                    label="TIN"
                    name="tin"
                    value={editedData.tin || ""}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    required
                  />
                </>
              ) : (
                <>
                  <Typography variant="body1" gutterBottom>
                    <strong>Vendor Number:</strong>{" "}
                    {userData.vendorNo || "Not assigned"}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <strong>Business Name:</strong> {userData.vendorName}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <strong>TIN:</strong> {userData.tin}
                  </Typography>
                </>
              )}
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
                Contact Information
              </Typography>

              {isEditing ? (
                <>
                  <TextField
                    label="Email"
                    name="email"
                    value={editedData.email || ""}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    type="email"
                    required
                  />
                  <TextField
                    label="Phone"
                    name="phoneNo"
                    value={editedData.phoneNo || ""}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    type="tel"
                  />
                </>
              ) : (
                <>
                  <Typography variant="body1" gutterBottom>
                    <strong>Email:</strong> {userData.email}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <strong>Phone:</strong> {userData.phoneNo || "Not provided"}
                  </Typography>
                </>
              )}
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
                Business Details
              </Typography>

              {isEditing ? (
                <>
                  <FormControl fullWidth margin="normal">
                    <InputLabel>Currency</InputLabel>
                    <Select
                      label="Currency"
                      name="currency"
                      value={editedData.currency || "UGX"}
                      onChange={handleChange}
                    >
                      {currencies.map((currency) => (
                        <MenuItem key={currency.code} value={currency.code}>
                          {currency.code}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl fullWidth margin="normal">
                    <InputLabel>Country</InputLabel>
                    <Select
                      label="Country"
                      name="country"
                      value={editedData.country || "Uganda"}
                      onChange={handleChange}
                    >
                      {countries.map((country) => (
                        <MenuItem key={country.Name} value={country.Name}>
                          {country.Name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </>
              ) : (
                <>
                  <Typography variant="body1" gutterBottom>
                    <strong>Currency:</strong> {userData.currency}
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    <strong>Country:</strong> {userData.country}
                  </Typography>
                </>
              )}
            </Box>

            <Box>
              <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold" }}>
                Validate
              </Typography>
              {/* {userData.vendorNo ? (
                                <Box display="flex" alignItems="center" gap={1}>
                                    <CheckCircleIcon color="success" fontSize="large" />
                                    <Typography variant="body1" color="success.main">
                                        Validated
                                    </Typography>
                                </Box>
                            ) : ( */}
              {
                <Button
                  variant="contained"
                  sx={{ backgroundColor: "green" }}
                  onClick={handleValidate}
                  disabled={validationLoading}
                >
                  {validationLoading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    "Validate"
                  )}
                </Button>
              }
              {/* {(<Button
                                variant="contained"
                                sx={{ backgroundColor: "green",marginLeft: 2 }}
                                onClick={setContacts}
                                disabled={contactLoading}
                            >
                                {contactLoading ? <CircularProgress size={24} color="inherit" /> : 'Set Contacts'}
                            </Button>
                            )} */}
            </Box>
          </Box>
        </Paper>
      </Container>

      <Snackbar
        open={!!validationResult}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={validationResult?.success ? "success" : "error"}
          sx={{ width: "100%" }}
        >
          {validationResult?.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default UserProfile;
